import type { MittwaldAPIV2 } from "@mittwald/api-client-NEXT";

export type SystemSoftwareData =
  MittwaldAPIV2.Operations.AppGetSystemsoftware.ResponseData;

export type SystemSoftwareListItemData =
  MittwaldAPIV2.Operations.AppListSystemsoftwares.ResponseData[number];

export type SystemSoftwareListQueryData =
  MittwaldAPIV2.Paths.V2SystemSoftwares.Get.Parameters.Query;

export type SystemSoftwareName =
  | "composer"
  | "gs"
  | "gm"
  | "im"
  | "mc"
  | "mysql"
  | "nano"
  | "node"
  | "pdftools"
  | "perl"
  | "php"
  | "python"
  | "redis-cli"
  | "webp"
  | "wp-cli";

export enum SystemSoftwareFullNames {
  composer = "Composer",
  gs = "Ghostscript",
  gm = "GraphicsMagick",
  im = "ImageMagick",
  mc = "Midnight Commander",
  mysql = "MySQL",
  nano = "nano",
  node = "Node.js",
  pdftools = "PDF Tools",
  perl = "Perl",
  php = "PHP",
  python = "Python",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  "redis-cli" = "Redis CLI",
  webp = "WebP",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  "wp-cli" = "WP-CLI",
}
